import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { CheckCircle2, LogIn } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { LoginShell, StepTitle } from "../components/login/LoginShell";
import { NewPasswordForm } from "../components/login/NewPassword";
import { Button } from "../components/ui/button";

// /reset/:token: the page the set-password / reset email links to. One use, 60 minutes.
export default function ResetPasswordPage() {
  const { token } = useParams();
  const { resetPassword, gated } = useAuth();
  const [saved, setSaved] = useState(null);

  return (
    <LoginShell gated={gated}>
      {saved ? (
        <div data-testid="reset-done" className="space-y-5">
          <span className="grid h-12 w-12 place-items-center rounded-2xl bg-[#ffc700]/30 text-[#1f1f24]">
            <CheckCircle2 className="h-6 w-6" />
          </span>
          <StepTitle title="Password saved">
            You can sign in with {saved.email} and your new password now. Any other devices were signed out.
          </StepTitle>
          <Button asChild data-testid="reset-signin-btn" className="h-12 w-full rounded-full font-bold gap-2">
            <Link to="/login"><LogIn className="h-4 w-4" /> Sign in</Link>
          </Button>
        </div>
      ) : (
        <NewPasswordForm
          title="Choose your password"
          intro="Pick a password for your Duckify account. Your ducks and orders stay exactly as they are."
          onSubmit={async (next) => setSaved(await resetPassword(token, next))}
        />
      )}
    </LoginShell>
  );
}
